/**
 * Rotating phone numbers for provider cards injected after page load.
 *
 * mapi-js only fetches brand codes present at first load. For markup added later, fetch the new
 * codes first, then refresh. If mapi-js is missing or fails, the static number stays in place.
 *
 * @param {Element|null} container Element that received the injected markup.
 */
export function refreshRotatingNumbers(container) {
    if (!container || !window.MAPI?.fetchTokenNumbers) {
        return;
    }

    // Array.from and indexOf, not spread: the build targets ES5 without iteration support, so spreading a
    // NodeList or a Set compiles to an empty array and nothing would ever be requested.
    const codes = Array.from(container.querySelectorAll('.cl-phone[data-token]'))
        .map((el) => el.dataset.token)
        .filter((code, i, all) => code && all.indexOf(code) === i);

    if (!codes.length) {
        return;
    }

    window.MAPI.fetchTokenNumbers(codes)
        .then(() => window.MAPI.refreshNumbers?.())
        .catch(() => {});
}
